import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { ContractObservationViewStore } from "../../store/ContractObservationViewStore";
import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { InputHtmlString } from "../../../common/controls";
import { FormControl } from "@mui/material";
import { ShowBoolean } from "../../../common/controls";
import { ShowReferenceSet } from "../../../common/controls";

export type ContractObservationViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  titleValue?: { displayId: string; id: string } | null;
  title: string;
  observationValue?: { displayId: string; id: string } | null;
  observation: string;
  requireAllValue?: { displayId: string; id: string } | null;
  requireAll: boolean;
  authorsValues: { displayId: string; id: string }[];
  publishersValues: { displayId: string; id: string }[];
  contractObservationViewStore: ContractObservationViewStore;
};

export const ContractObservationViewForm: React.FC<ContractObservationViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      title = "",
      observation = "",
      requireAll = false,
      authorsValues,
      publishersValues,
      contractObservationViewStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupContractObservationLabel}
              collapsible={true}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={title}
                  label={langStore.ContractObservationTitleLabel}
                />
                <InputHtmlString
                  value={observation}
                  onChange={() => {}}
                  label={langStore.ContractObservationObservationLabel}
                  readOnly={true}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="filters"
              title={langStore.groupContractObservationFiltersLabel}
              description={langStore.groupContractObservationFiltersDescription}
              collapsible={true}
              expanded={contractObservationViewStore.getCardState("filters")}
              toggleExpand={() =>
                contractObservationViewStore.toggleCardState("filters")
              }
            >
              <FormControl fullWidth>
                <ShowBoolean
                  value={requireAll}
                  label={langStore.ContractObservationRequireAllLabel}
                />
                <ShowReferenceSet
                  label={langStore.ContractObservationAuthorsLabel}
                  selectedValues={authorsValues}
                />
                <ShowReferenceSet
                  label={langStore.ContractObservationPublishersLabel}
                  selectedValues={publishersValues}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
